export default __webpack_public_path__ + "static/media/habitat.96925082.png";